export const notifyRejectReservationSuccess = (toast, t) => {
    toast.success({
        message: t("resDetails.reservationWasRejected"),
        description: t("resDetails.reservationRejectedByAdmin"),
    });
};

export const notifyRejectReservationError = (toast, t, error) => {
    toast.error({
        message: t("resDetails.couldNotReject"),
        description: error?.response?.data?.message || t("resDetails.errorSavingRes"),
    });
};
